<template src="./ExternalProviderToken.html"></template>

<script>
import mixins from "../../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  name: "externalProviderToken",
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return { 
      externalProviderToken: [],
      externalProviderTokenFiltered: [],
      externalProviderList: [],
      serviceFilter: "",
      defaultTableText: "Aguarde, estamos carregando as informações...",
      quantity: 1,
      validityMonths: 1,
      customerPlanList: [],
      service: {
        id: null,
        externalProviderId: 0,
        customerPlanId: 0,
        quantity: 1
      },
      invalid: {
        externalProviderId: false,
        customerPlanId: false,
        serviceDescription: false,
      },
      modalTitle: "",
      disableModalEdit: false,
      enablePagination: true,
      windowWidth: 0,
      numPages: 1,
      currentx: 1,
      pagination: false,
    }
  },
  mounted: function() {
    this.init()
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  watch: {
    serviceFilter: function (string) {
      if (string === "") {
        this.enablePagination = true
        this.changePagination()
      }
      else {
        this.enablePagination = false
        this.externalProviderTokenFiltered = this.externalProviderToken.filter( 
            serv => (serv.name.toLowerCase().includes(string.toLowerCase()))
        ) 
      }
    },
    currentx: function () {
      this.changePagination();
    },
  },
  methods: {
    init() {
      this.getExternalProviderToken()
    },
    getExternalProviderToken() {
      this.axios.get(`${this.$store.state.filooServer}external-provider-token`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( res => {
          this.defaultTableText = "Nenhum resultado encontrado"
          if (res.data.length > 0) {
            this.externalProviderToken = res.data
            this.externalProviderTokenFiltered = this.externalProviderToken
            this.numPages = Math.ceil(this.externalProviderTokenFiltered.length / 10)
            this.pagination = this.numPages > 1
            this.changePagination()
          }
        })
        .catch( err => {
          this.defaultTableText = "Nenhum resultado encontrado"
          console.log({
            endpointURL: "external-provider-token",
            error_getExternalProviderToken: err,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao buscar a lista de Tokens. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })

        this.axios.get(`${this.$store.state.filooServer}external-provider`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( res => {
          if (res.data.length > 0) {
            this.externalProviderList = res.data
          }
        })
        .catch( err => {
          this.defaultTableText = "Nenhum resultado encontrado"
          console.log({
            endpointURL: "external-provider-token",
            error_getExternalProviderToken: err,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao buscar a lista de Tokens. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })

        this.axios.get(`${this.$store.state.filooServer}customerplan/actives`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( res => {
          if (res.data.length > 0) {
            this.customerPlanList = res.data
          }
        })
        .catch( err => {
          this.defaultTableText = "Nenhum resultado encontrado"
          console.log({
            endpointURL: "external-provider-token",
            error_getExternalProviderToken: err,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao buscar a lista de Tokens. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })
    },
    checkFields() {
      let readyToUpdate = true
      if (!this.service.externalProviderId) {
        this.invalid.externalProviderId = true
        readyToUpdate = false
      }
      if (!this.service.customerPlanId) {
        this.invalid.customerPlanId = true
        readyToUpdate = false
      }
      if (this.quantity <= 0) {
        this.invalid.quantity = true
        readyToUpdate = false
      }
      if (readyToUpdate) this.updateService()
      else return false 
    },
    updateService() {     
      const method = this.service.id ? "put" : "post"
      const URLSuffix = method === "put" ? `/${this.service.id}` : "" 
      this.axios({
        method,
        url: `${this.$store.state.filooServer}external-provider-token`,
        data: {
          customerPlanId: this.service.customerPlanId.id,
          externalProviderId: this.service.externalProviderId.id,
          quantity: this.quantity,
          validityMonths: this.validityMonths
        }
      })
      .then( () => {
        this.$bvModal.hide("modal-register-new-service")
        const messagem = method === "post" ? 
          "Serviço de planos adicionado com sucesso!" : 
          "Serviço de planos atualizado com sucesso!"
        this.showNotifySuccess(
          "Sucesso", 
          messagem, 
          5000,
        )
        this.getExternalProviderToken()
      })
      .catch( err => {
        console.log({
          endpointURL: `plan-services${URLSuffix}`,
          error_updateService: err,
        })
        this.$bvModal.hide("modal-register-new-service")
        this.showNotifyWarning(
          "Não foi possível realizar a transação. Por favor, tente novamente mais tarde!", 
          5000,
        )
      })
    },
    handleSelected(tr) {
      this.service = { ...null }
      this.service.id = tr.id
      this.modalTitle = "Editar serviço"
      this.disableModalEdit = true
      this.$bvModal.show("modal-register-new-service")
      this.axios.get(`${this.$store.state.filooServer}plan-services/${tr.id}`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( res => {
          this.service = { ...res.data }
          this.disableModalEdit = false
        })
        .catch( err => {
          console.log({
            endpointURL: `plan-services/${tr.id}`,
            error_handleSelected: err,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao tentar selecionar o serviço. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })
    },
    handleNewService() {
      this.service = { ...null }
      this.modalTitle = "Novo(s) Token(s)"
      this.$bvModal.show("modal-register-new-service")
    },
    changePagination() {
      const firstElement = (this.currentx - 1) * 10
      const lastElement = firstElement + 10
      this.externalProviderTokenFiltered = this.externalProviderToken.slice(firstElement , lastElement)
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    changeTokenStatus(id, active) {
      const method = "put"
      const vm = this;
      vm.axios({
          method,
          url: `${this.$store.state.filooServer}external-provider-token`,
        data: {
          id,
          active
        }
      })
        .then(function(response) {
          if (response.status == 200) {
            vm.getExternalProviderToken();
          }
        });
    },
  },
}
</script>

<style lang="scss" src="./ExternalProviderToken.scss">
</style> 